module.exports = __webpack_public_path__ + "static/carbon-8b67681879a5cc95df2c3f476a0d1984.mp4";